import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=51035d2d&"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=51035d2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports